import { Typography } from '@scale/scaleui';
import { CommunityManagementContent } from 'react-scale/components/ExpertManagement/CommunityManagement/CommunityManagementContent';

export const CommunityManagementPage: React.FC = () => {
  return (
    <div className="p-8 h-full flex flex-col items-start">
      <Typography.H4>Community Management</Typography.H4>
      <CommunityManagementContent />
    </div>
  );
};
